module.exports = __webpack_public_path__ + "3dc253a308361d8ab85c1e2c27848660.pdf";